import React from 'react'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion'

import ReactMarkdown from 'react-markdown'

const Accord = ({ heading, opts }) => (
  <div className="accord">
    <h2>{heading}</h2>
    <Accordion allowZeroExpanded>
      {opts.map((opt, i) => (
        <AccordionItem key={i}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <span className="toggle" />
              {opt.title}
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemState>
            {({ expanded }) => (
              <AccordionItemPanel
                className={
                  expanded
                    ? 'accordion__panel'
                    : 'accordion__panel accordion__panel--hidden'
                }
              >
                <ReactMarkdown>{opt.answer}</ReactMarkdown>
              </AccordionItemPanel>
            )}
          </AccordionItemState>
        </AccordionItem>
      ))}
    </Accordion>
  </div>
)

export default Accord
